<template>
  <div class="MAM_brandList">
    <!-- 表单搜索部分 -->
    <el-card class="box-card" shadow="hover">
      <el-form :inline="true" :model="searchFrom" class="demo-form-inline">
        <el-form-item>
          <el-input
              size="medium"
              clearable
              v-model="searchFrom.title"
              placeholder="请输入政策名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
              size="medium"
              clearable
              v-model="searchFrom.up_code"
              placeholder="请输入政策编码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
              size="medium"
              type="primary"
              icon="el-icon-search"
              style="font-size: 12px;"
              @click="onSubmit"
          >查询</el-button>

         <!-- <el-button
              size="medium"
              type="primary"
              icon="el-icon-plus"
              style="font-size: 12px;"
              @click="handleAddBrand"
          >添加政策</el-button> -->

        </el-form-item>
      </el-form>
    </el-card>
    <!-- 表格部分 -->
    <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
      <el-table
          :data="brandTable.list"
          size="mini"
          border
          style="width: 100%"
          max-height="500px"
          v-loading="loading"
      >
        <el-table-column
            header-align="center"
            align="center"
            fixed
            prop="id"
            label="ID"
            min-width="80"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="title"
            label="政策名称"
            min-width="120"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="nums"
            label="调价数量"
            min-width="120"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="new_update_rate"
            label="调价后的费率(%)"
            min-width="120"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="update_sec_fee"
            label="秒到费(元)"
            min-width="120"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="up_code"
            label="调价政策编码"
            min-width="120"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="notes"
            label="备注"
            min-width="120"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="create_time"
            label="创建时间"
            min-width="150"
        ></el-table-column>
        <!-- 操作 -->
        <!-- <el-table-column
            header-align="center"
            align="center"
            fixed="right"
            label="操作"
            min-width="150"
        >
            <template slot-scope="scope">
                <el-button
                    @click="handleDelete(scope.$index,scope.row)"
                    type="text"
                    size="small"
                >删除</el-button>
            </template>
        </el-table-column> -->
      </el-table>
      <!-- 分页部分 -->
      <paginations
          :currentPage="page.currentPage"
          :pageSize="page.pageSize"
          :total="page.total"
          @watchCurrent="getCurrent"
          @watchPageSize="getPageSize"
      ></paginations>
    </el-card>
    <el-dialog title="新增信息" :visible.sync="addBrand" width="40%" :before-close="handleClose">
      <el-form :model="formInline"  :rules="rules" ref="formInline"  size="small" class="demo-form-inline" label-width="120px" label-position="left">

        <el-form-item label="政策名称" prop="title">
          <el-input v-model="formInline.title" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="调价后的费率(%)" prop="new_update_rate">
          <el-input v-model="formInline.new_update_rate"  oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="秒到费金额(元)">
          <el-input v-model="formInline.update_sec_fee" oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="formInline.notes">
          </el-input>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
        		<el-button @click="handleClose()">取 消</el-button>
        		<el-button type="primary" @click="determine()">确 定</el-button>
        	</span>
    </el-dialog>



  </div>
</template>

<script>
import paginations from '../../../components/pagination/paginations';
export default {
  name: "MAM_brandList",
  inject: ['reload'],
  components: {
    paginations,
  },
  data() {
    return {
      brandId: null,
      brandName:'',
      addBrand: false,
      searchFrom: {},
      brandTable: {
        list: [],
      },
      formInline:{},
      rules: {
        title: [
          { required: true, message: '请输入政策名称', trigger: 'blur' },
        ],
        new_update_rate: [
          { required: true, message: '请输入调价后的费率', trigger: 'blur' },
        ],
      },
      page: {
        currentPage: 1, //当前页码
        pageSize: 10, //条数
        total: 0  //总数
      },
      loading: true,
    }
  },
  mounted() {
    this.getData({
      page: this.page.currentPage,
      limit: this.page.pageSize,
    })
  },

  methods: {

    //搜索
    onSubmit() {
      this.loading = true;
      // 表单提交
      this.getData({
        page: 1,
        limit: this.page.pageSize,
        name: this.searchFrom.name,
        title:this.searchFrom.title,
        up_code:this.searchFrom.up_code
      })
    },
    //打开新增弹框
    handleAddBrand(){
      this.addBrand = true;
      this.formInline = {};
    },
    //关闭弹框
    handleClose(){
      this.addBrand = false;
      this.formInline = {};
    },
    //确定新增
    determine(){
      this.$refs['formInline'].validate((valid) => {
        if (valid) {
          this.$api.post("terminal/DebitCardPolicyAdd", this.formInline , res => {
            if (res.data.code == 1) {
              this.addBrand = false;
              this.getData({
                page: this.page.currentPage,
                limit: this.page.pageSize,
              })
              this.$message.success(res.msg);
              this.formInline = {};
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          return false;
        }
      });
    },
    //分页
    getCurrent(page) {
      // 获取当前页修改的值
      this.page.currentPage = page;
      this.loading = true;
      this.getData({
        page: this.page.currentPage,
        limit: this.page.pageSize,
      })
    },
    getPageSize(limit) {
      // 获取条数发生改变的值
      this.page.pageSize = limit;
      this.loading = true;
      this.getData({
        page: this.page.currentPage,
        limit: limit,
      })
    },
    getData(params) {
      this.$api.post("terminal/DebitCardPolicyList", params, res => {
        let data = res.data;
        this.page.total = data.count; //总数
        this.brandTable.list = res.data.list;
        //渲染结束后取消加载
        this.loading = false;
      })
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
